import { useEffect, useRef, useState } from 'react';
import imageActions from '../../redux/actions/imageActions';
import popupActions from '../../redux/actions/popupActions';
import previewActions from '../../redux/actions/previewActions';
import { withoutFormat } from '../../helpers/imageHelper';
import AnalyticsSender from '../../helpers/analyticsSender';
import {previews} from '../../content/previews';
import {createImage} from '../../helpers/canvasHelpers';
import canvasActions from '../../redux/actions/canvasActions';

const Update = (props: {service: string}) => {
	const { image, imageName, imageFormat, imageWidth, imageHeight } = imageActions();
	const { canvasImage, canvasWidth, canvasHeight } = canvasActions();
	const { previewItems, previewCategory, previewEditIndex, previewSetItems, previewSetPosition, previewPosition} = previewActions();
	const { isVisible, clearPopup } = popupActions();
  
	const analyticsSender = new AnalyticsSender();
  
	const [bias, setBias] = useState({ top: 0, left: 0 });
	const [startTouch, setStartTouch] = useState({ x: undefined, y: undefined });
	const [mouseClick, setMouseClick] = useState(false);

	const canvasPopupRef = useRef(null);

	const contentData = previews.previews[previewCategory][previewEditIndex];
	let imageDimension = { height: 0, width: 0};

	const itemWidth = props.service !== 'rotator' ? imageWidth : canvasWidth;
	const itemHeight = props.service !== 'rotator' ? imageHeight : canvasHeight;
  

	if(contentData) {
		imageDimension = imageResize(
			itemWidth, itemHeight,
			contentData.width, contentData.height
		);
	}


	useEffect(() => {

		if (contentData) {
			const position = previewPosition.filter(previewPosition => previewPosition.category === previewCategory && previewPosition.index == previewEditIndex);
      
			let customTop;
			let customLeft;
     
			if(position.length > 0) {
				const dataPosition = position.pop();
				customTop = dataPosition.top;
				customLeft = dataPosition.left;
    
			}

			setBias({
				top:  typeof customTop !== 'undefined' ? customTop : (contentData.height - imageDimension.height ) / 2,
				left: typeof customLeft !== 'undefined' ? customLeft : (contentData.width - imageDimension.width) / 2,
			});
		}
	}, [isVisible]);


	useEffect(() => {
		if (contentData) {
			const canvas: any = canvasPopupRef.current;
			const context: any = canvas.getContext('2d');
			createImage(props.service == 'resizer' ? image : canvasImage).then((imageSrc) => {
				context.clearRect(0, 0, imageDimension.width, imageDimension.height);

				context.drawImage(
					imageSrc,
					bias.left,
					bias.top,
					imageDimension.width,
					imageDimension.height
				);
			});
		}
	}, [bias]);


	if (!contentData) return <></>;

	const styleBackground = imageFormat === 'image/png' ? '#7f7f7f' : `url(${image})`;

	const canvasStyle = {
		height: contentData.width > contentData.height ? 'initial' : '100%',
		width: contentData.width > contentData.height ? '100%' : 'initial',
	};

	const clickDownload = () => {
		const link = document.createElement('a');
		link.href = canvasPopupRef.current.toDataURL('image/jpeg');
		link.setAttribute('download', withoutFormat(imageName) + '.jpg');

		link.click();
	};

	const clickClose = () => {
		previewSetPosition(previewCategory, previewEditIndex, Math.round(bias.top), Math.round(bias.left));
		previewSetItems(previewItems);
		setBias({ top: 0, left: 0 });
		clearPopup();
	
	};

	const mouseMoveTouch = (e => {
		e.persist();
		if (!e.targetTouches) return;


		if(startTouch.y === undefined && startTouch.x === undefined) {
			setStartTouch({x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY});
			return;
		}

		let diffY = e.targetTouches[0].clientY - startTouch.y;
    
		if(e.targetTouches[0].clientY - startTouch.y > 10) {
			diffY = 1;
		}
    
		if(e.targetTouches[0].clientY - startTouch.y < -10) {
			diffY = -1;
		}
    
		const moveY = bias.top + diffY;

		const maxYScroll = 0;
		const minYScroll = (imageDimension.height - contentData.height ) * -1;
		const canMoveY = moveY >= minYScroll && moveY <= maxYScroll;


		let diffX = e.targetTouches[0].clientX - startTouch.x;
    
		if(e.targetTouches[0].clientX - startTouch.x > 10) {
			diffX = 1;
		}
    
		if(e.targetTouches[0].clientX - startTouch.x < -10) {
			diffX = -1;
		}

		const moveX = bias.left + diffX;
		const maxXScroll = 0;
		const minXScroll = (imageDimension.width - contentData.width ) * -1;
		const canMoveX = moveX >= minXScroll && moveX <= maxXScroll;

    
		setBias({
			left: canMoveX ? moveX : bias.left, 
			top:  canMoveY ? moveY : bias.top, 
		});

		setStartTouch({x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY});

	});

	const mouseMoveSec = (e: any) => {
		e.persist();

		if(!mouseClick) return;

		const moveY = (bias.top + e.movementY);
		const maxYScroll = 0;
		const minYScroll = (imageDimension.height - contentData.height ) * -1;
		const canMoveY = moveY >= minYScroll && moveY <= maxYScroll;

		const moveX = (bias.left + e.movementX);
		const maxXScroll = 0;
		const minXScroll = (imageDimension.width - contentData.width ) * -1;
		const canMoveX = moveX >= minXScroll && moveX <= maxXScroll;

		setBias({
			top: canMoveY ? moveY : bias.top, 
			left: canMoveX ? moveX : bias.left, 
		});             
	};


	return (
		<>
			<h3>{contentData.title}</h3>
			<button
				className="popup__action"
				onClick={() => {
					clickClose();
					analyticsSender.sendClosePopupUpdate(previewCategory, contentData.title, `${contentData.width}x${contentData.height}`);
				}}
			>
				<i className="icon__remove"></i>
			</button>
			<div className="popup__update">
				<div className="popup__preview" style={{ width: '480px' }}>
					<div className="popup__preview-background" style={{background: styleBackground}}></div>
					<div className="popup__preview-image">
						<canvas
							style={canvasStyle}
							width={contentData.width}
							height={contentData.height}
							ref={canvasPopupRef}
							onMouseUp={() => { setMouseClick(false); analyticsSender.sendChangePreview(previewCategory, contentData.title, `${contentData.width}x${contentData.height}`); }}
							onMouseDown={() => setMouseClick(true)}
							onMouseOver={() => setMouseClick(false)}
							onMouseMove={(e) => {
								mouseMoveSec(e);
							}}
             
							onTouchEnd={() => {
								analyticsSender.sendChangePreview(previewCategory, contentData.title, `${contentData.width}x${contentData.height}`);
							}}
							onTouchMove={(e) => {
								mouseMoveTouch(e);
							}}
            
						/>
					</div>
				</div>
				<div className="popup__description">
					<h3>
              
						{`${contentData.width}px x ${contentData.height}px`}
					</h3>
					<p>{contentData.description}</p>

					<button onClick={() => { clickDownload(); analyticsSender.sendDownloadPopupUpdate(previewCategory, contentData.title, `${contentData.width}x${contentData.height}`); }} type="button">
            Download
					</button>
				</div>
			</div>
		</>
	);
};

export default Update;

const imageResize = (imageWidth, imageHeight, itemWidth, itemHeight) => {
	const imageWidthProperties = imageWidth / itemWidth;
	const imageHeightProperties = imageHeight / itemHeight;

	const resizeProperties =
    imageWidthProperties < imageHeightProperties
    	? imageWidthProperties
    	: imageHeightProperties;

	return {
		width: imageWidth / resizeProperties,
		height: imageHeight / resizeProperties,
	};
};
